<div class="estructuras__header d-flex">
  <h2 class="estructuras__title" style="font-family: 'montserrat-semibold';
font-size: 20px">
    {{ "NOVEDADES_DEL_SISTEMA" | translate }}
  </h2>
</div>
<div [innerHtml]="detalle" id="detalle" ></div>
